import Button from "core/buttons/button/Button";
import _ from "lodash";
import { ACTIONS, ENTITIES, VAR_TYPES } from "constants/constants";
import { FormattedMessage } from "react-intl";
import { TableManager } from "components/bo/admin-table/TableManager";
import { getLastAndNextFiveYears, getLastFiveYear } from "utils/functions";
import { navigateView, navigateEdit, navigateToParent } from "utils/boHelper";
import { useCountryContext } from "api/settings/country/CountryProvider";
import { useCountryHolidaysContext } from "api/settings/country-holidays/CountryHolidaysProvider";
import { useEffect, useState } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { useUserContext } from "api/user/UserProvider";
import { HandleModaleBO } from "components/bo/HandleModaleBO";

const AdminCountryHolidays = ({ action }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const { id } = useParams();
  const {
    getCountryHolidaysList,
    getCountryHolidaysById,
    createCountryHolidays,
    updateCountryHolidaysById,
    countryHolidaysList,
    countryHolidaysPerId,
    deleteCountryHolidaysById,
  } = useCountryHolidaysContext();
  const { countryList, countryListGetter } = useCountryContext();
  const { userScope } = useUserContext();

  const [inputs, setInputs] = useState([]);
  const [minDate, setMinDate] = useState(getLastFiveYear());
  const [deleteData, setDeleteData] = useState(null);

  useEffect(() => {
    getCountryHolidaysList();
    countryListGetter();
  }, []);
  useEffect(() => {
    if (id) {
      getCountryHolidaysById(id);
    }
  }, [id]);

  const handleCreate = (payload) => {
    try {
      createCountryHolidays({
        ...payload,
        holiday: payload?.holiday?.map((elm) => ({ date: elm })),
        country_id: Number(payload?.country_id),
      });
      navigateToParent(navigate, location);
    } catch (e) {
      console.error(e);
    }
  };
  const handleEdit = (payload) => {
    try {
      updateCountryHolidaysById(payload.id, {
        ...payload,
        holiday: payload?.holiday?.map((elm) => ({ date: elm })),
      });
      navigate(`/${userScope}/settings/country-holidays/${payload?.slug}`);
    } catch (e) {
      console.error(e);
    }
  };
  const formatCountryHoliday = (countryHoliday) =>
    countryHoliday?.id
      ? {
          ...countryHoliday,
          holiday: _.chain(countryHoliday?.holiday)
            .map("date")
            .join(", ")
            .value(),
          country_id: countryList.find(
            (e) => e.id === countryHoliday?.country_id
          )?.name,
        }
      : "";
  const formatList = (list) =>
    list.map((elm) => ({
      ...elm,
      holiday:
        action === ACTIONS?.LIST
          ? _.chain(elm?.holiday).map("date").join(", ").value()
          : elm?.holiday,
      country_id:
        elm.country_id && countryList?.length > 0
          ? countryList?.find((e) => e.id === elm.country_id)?.name
          : null,
    }));

  const handleDelete = (holidayId) => {
    const countryHolidayToDelete = countryHolidaysList.find(
      (e) => e.id === holidayId
    );
    setDeleteData({
      ...countryHolidayToDelete,
      holiday: _.chain(countryHolidayToDelete?.holiday)
        .map("date")
        .join(", ")
        .value(),
    });
  };
  useEffect(() => {
    if (countryList.length > 0) {
      const choices = [{ name: "", value: null }].concat(
        countryList.map((e) => ({
          name: e.name,
          value: e.id.toString(),
        }))
      );
      setInputs([
        {
          col: "country_id",
          mandatory: true,
          editable: true,
          isMissingValue: null,
          type: VAR_TYPES.DROPDOWN,
          choices,
        },
        {
          col: "year",
          mandatory: true,
          isMissingValue: null,
          type: VAR_TYPES.DROPDOWN,
          choices: getLastAndNextFiveYears()?.map((e) => ({
            name: e,
            value: e,
          })),
          getYear: (val) => {
            setMinDate(val);
          },
        },
        {
          col: "holiday",
          type: VAR_TYPES.MULTI_DATES,
          mandatory: true,
          isMissingValue: null,
        },
      ]);
    }
  }, [countryList]);

  return (
    <div>
      {action === ACTIONS.LIST && (
        <div className="flex">
          <Button
            className="btn-hover-color"
            size="large"
            color="blue"
            onClick={() => navigateView("new", navigate, location)}
          >
            <FormattedMessage
              id={"admin_create_new"}
              defaultMessage={"Nouveau"}
            />
          </Button>
        </div>
      )}
      <br />
      <TableManager
        action={action}
        entity={ENTITIES.COUNTRY_HOLIDAYS}
        entityPerId={countryHolidaysPerId}
        formattedEntity={formatCountryHoliday(countryHolidaysPerId)}
        list={formatList(countryHolidaysList)}
        inputs={inputs}
        navigateEdit={(propsId) => navigateEdit(propsId, navigate, location)}
        navigateView={(propsId) => navigateView(propsId, navigate, location)}
        handleCreate={handleCreate}
        handleDelete={handleDelete}
        handleEdit={handleEdit}
        getYear={setMinDate}
        minDate={`${minDate}-01-01`}
      />
      <div id="modalDelete">
        <HandleModaleBO
          setDeleteData={setDeleteData}
          validateDelete={deleteCountryHolidaysById}
          deleteData={deleteData}
          entity={ENTITIES.COUNTRY_HOLIDAYS}
        />
      </div>
    </div>
  );
};

export default AdminCountryHolidays;
